// extracted by mini-css-extract-plugin
module.exports = {"page-wrapper":"pagination_page-wrapper__HAatQ","page":"pagination_page__J59QV","page-btn":"pagination_page-btn__THvD7"};